export default __webpack_public_path__ + "static/media/jose-1199x1199.18792a74.webp";